/**
 * Fellowship themes configuration
 */

// Theme list for dropdown/checkbox selections
export const FELLOWSHIP_THEMES = [
  "Children's Books",
  "Climate Action & Renewable Energy",
  "Cultural Identity",
  "Defense & Foreign Policy",
  "Economy",
  "Governance",
  "Healthcare",
  "India's Frontier States",
  "Infrastructure (Physical & Digital)",
  "Nation First",
  "Renaissance of India's Global Presence",
  "Social Sector",
  "Technology & Entrepreneurship",
  "Women Empowerment",
  "Youth Empowerment",
];

// Theme options with key-value pairs for form handling
export const THEME_OPTIONS = {
  governance: "Governance",
  culturalIdentity: "Cultural Identity",
  infrastructure: "Infrastructure (Physical & Digital)",
  economy: "Economy",
  nationFirst: "Nation First",
  defenseAndForeignPolicy: "Defense & Foreign Policy",
  renaissanceOfIndiasGlobalPresence: "Renaissance of India's Global Presence",
  indiasFrontierStates: "India's Frontier States",
  climateActionAndRenewableEnergy: "Climate Action & Renewable Energy",
  womenEmpowerment: "Women Empowerment",
  socialSector: "Social Sector",
  healthcare: "Healthcare",
  childrensBooks: "Children's Books",
  technologyAndEntrepreneurship: "Technology & Entrepreneurship",
  youthEmpowerment: "Youth Empowerment",
  others: "Others",
};

// Fellowship program options
export const FELLOWSHIP_PROGRAMS = [
  "BlueKraft Associate Fellowship",
  "BlueKraft Senior Fellowship",
  "BlueKraft Distinguished Fellowship",
];
